import src from "IMAGE";
export default { src, width: 258, height: 258, blurWidth: 0, blurHeight: 0};
